
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2211',
  depVersions: {
  "customer-portal-app": "static-1.2211",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.465",
  "data-fetching-client": "static-1.9643",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.428",
  "growth-payments-core": "static-1.25282",
  "head-dlb": "static-1.4938",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5565",
  "hs-test-utils": "static-1.7985",
  "hub-http": "static-1.6193",
  "hub-http-shared-msw-handlers": "static-1.9886",
  "hubspot-dlb": "static-2.1832",
  "hubspot-prosemirror": "static-1.18156",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11436",
  "I18n": "static-7.1615",
  "immutable": "static-2.77",
  "jasmine-runner": "static-1.6438",
  "payment-link-components": "static-1.23447",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6986",
  "quartz-core": "static-1.6205",
  "react": "static-7.185",
  "react-colorpicker": "static-2.10181",
  "react-dlb": "static-1.78",
  "react-utils": "static-2.5319",
  "rich-text-lib": "static-1.19775",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17940",
  "ui-components-test-utils": "static-1.5574",
  "UIComponents": "static-3.8383",
  "foundations-assets": "static-1.4834",
  "foundations-components": "static-1.7868",
  "foundations-theming": "static-1.4388",
  "foundations-theming-specialty": "static-1.2104",
  "framer-motion": "static-1.71",
  "metrics-js": "static-1.9542",
  "PortalIdParser": "static-2.388",
  "portals-platform-lib": "static-1.850",
  "quartz-config": "static-1.764",
  "quartz-routing": "static-1.416",
  "quick-fetch": "static-1.3891",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16640",
  "rpc-client-utils": "static-1.4622",
  "sanitize-text": "static-1.8113",
  "styled-components": "static-2.88",
  "tanstack-table": "static-1.54",
  "ui-addon-draggable": "static-3.4739",
  "ui-addon-react-router-dom": "static-1.9515",
  "usage-tracker": "static-1.7316",
  "usage-tracker-anonymous": "static-1.5733",
  "usage-tracker-core": "static-1.7166",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3378",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3263",
  "quartz-webpack": "static-1.3210",
  "bend-plugin-quartz-routing": "static-1.64",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.81",
  "customer-data-objects": "static-1.7633",
  "frontend-preferences-client": "static-1.7900",
  "laboratory-lib": "static-3.7130",
  "onboarding-scopes": "static-1.6433",
  "ui-addon-opt": "static-4.8341",
  "HeadJS": "static-2.746",
  "hs-test-utils-bend-plugin": "static-1.3096",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.60",
  "ts-schema": "static-1.4053",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7703",
  "cssUtils": "static-1.782",
  "customer-data-ui-utilities": "static-1.9797",
  "HubStyle": "static-2.11744",
  "knowledge-content-types": "static-1.8483",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.661",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.486",
  "ui-addon-emoji-picker": "static-1.9858",
  "ui-addon-i18n": "static-1.11121",
  "ui-business-units-lib": "static-1.9020",
  "ui-shepherd-react": "static-3.10125",
  "video-components-external": "static-1.11168",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4297",
  "commerce-tours-lib": "static-1.6034",
  "customer-data-properties": "static-1.51433",
  "getting-started-shared-tasks": "static-1.18415",
  "growth-onboarding-reliability": "static-1.5054",
  "onboarding-tours": "static-1.16539",
  "reference-resolvers-lite": "static-1.8066",
  "sales-checkout-service-client": "static-1.3610",
  "ui-addon-iframeable": "static-1.9028",
  "user-context": "static-1.5073",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.828",
  "hubspotter-http": "static-1.4627",
  "icons": "static-2.644",
  "mobile-manifest-mixins": "static-1.520",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.661",
  "quartz-head": "static-1.651",
  "quartz-test": "static-1.661",
  "quartz-tracking": "static-1.365",
  "ui-fonts": "static-1.698",
  "usage-tracker-container": "static-1.7306",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9399",
  "data-token-picker": "static-1.16351",
  "FileManagerLib": "static-1.39169",
  "property-translator": "static-1.5372",
  "atom": "static-1.5042",
  "merchandise-lib": "static-1.262",
  "purchase-motions-components": "static-1.5825",
  "salesImages": "static-1.524",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5351",
  "react-select-plus": "static-1.104",
  "react-virtualized": "static-2.98",
  "ui-images": "static-2.1143",
  "bend-plugin-foundations-components": "static-1.4137",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.13",
  "trellis-assets": "static-1.1770",
  "bend-plugin-foundations-theming": "static-1.2871",
  "foundations-theming-base": "static-1.3373",
  "stylex": "static-1.32",
  "interframe": "static-3.4731",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5730",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "web-vitals": "static-1.4",
  "bend-plugin-chirp-manifest": "static-1.32",
  "chirp-fetch": "static-1.1858",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4446",
  "react-flip-move": "static-1.69",
  "bender-build-tools": "static-1.3160",
  "inbound-db-properties-service-client": "static-1.3818",
  "superstore": "static-1.4736",
  "feedback-loader": "static-1.29238",
  "ai-components-ui-library": "static-1.8859",
  "ui-addon-video-player": "static-1.8671",
  "ui-coaching-tips": "static-1.28461",
  "sassPrefix": "static-1.155",
  "react-dnd-compat": "static-1.4591",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2469",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8140",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4620",
  "content-media-composition-data-lib": "static-1.12154",
  "content-media-compositions": "static-2.16161",
  "idb-keyval": "static-1.43",
  "immer": "static-1.33",
  "immerable": "static-1.4125",
  "magpie-lib": "static-1.5537",
  "magpie-types": "static-1.4997",
  "media-bridge-lib": "static-1.18871",
  "video-data-lib": "static-1.34826",
  "commerce-products-lib": "static-1.9437",
  "crm-message-bus": "static-1.42906",
  "growth-data-modal": "static-1.5379",
  "hubspot-apollo-client": "static-1.4848",
  "onboarding-tours-client": "static-1.4753",
  "calling-global-api": "static-1.64410",
  "calling-internal-common": "static-1.31274",
  "calling-lifecycle-internal": "static-1.65792",
  "calling-lifecycle-messages": "static-1.58086",
  "conditional-properties-service-client": "static-1.3772",
  "crm-links": "static-1.6256",
  "customer-data-objects-ui-components": "static-1.12996",
  "customer-data-properties-shared-msw-handlers": "static-1.9213",
  "customer-data-property-utils": "static-1.8056",
  "external-options-client-types": "static-1.4133",
  "file-manager-components": "static-1.23529",
  "framework-data-schema-resolvers": "static-1.6852",
  "google-libphonenumber": "static-1.37",
  "hs-resources": "static-1.123",
  "inbound-db-meta-service-client": "static-1.3565",
  "inbounddb-objects-service-types": "static-1.4198",
  "meetings-icalendar-utils-lib": "static-1.603",
  "multi-currency-client-types": "static-1.3666",
  "object-builder-ui-client": "static-1.48630",
  "pipeline-validation-client-types": "static-1.3940",
  "property-value-citations": "static-1.2047",
  "pulse": "static-1.535",
  "smart-property-lib": "static-1.6761",
  "tiered-pricing": "static-1.1134",
  "ui-addon-form-validation": "static-1.10961",
  "growth-onboarding-confetti": "static-1.3038",
  "growth-onboarding-next-action-utils": "static-1.1831",
  "navigation-components": "static-1.17935",
  "onboarding-tours-utils": "static-1.605",
  "ui-shepherd-tracker": "static-1.7506",
  "ui-universal-auth": "static-1.8941",
  "batch-promise": "static-1.1513",
  "navigation-messaging": "static-1.7262",
  "getting-started-shared-tasks-store": "static-1.17533",
  "hubspotter-http-shared-msw-handlers": "static-1.9884",
  "usage-tracker-session-replay": "static-1.5002",
  "audio-components": "static-1.5868",
  "FileManagerCore": "static-1.39028",
  "FileManagerImages": "static-1.36680",
  "video-components": "static-1.13171",
  "foundations-components-legacy": "static-1.893",
  "purchase-motions-api": "static-1.5828",
  "self-service-api": "static-1.10216",
  "signup-constants": "static-1.18786",
  "signup-ui-url-generator": "static-2.8011",
  "trials-service-types": "static-1.3874",
  "usage-tracker-public": "static-1.7127",
  "chatspot-core": "static-1.21142",
  "ContentUtils": "static-1.68268",
  "copilot-toolkit": "static-1.11052",
  "growth-onboarding-feedback-components": "static-1.6553",
  "reactive-lib": "static-1.693",
  "simple-logging-lib": "static-1.3020",
  "commerce-permissions": "static-1.737",
  "customer-data-tracking": "static-1.6856",
  "products-iframe-lib": "static-1.7844",
  "products-ui-components-shared-msw-handlers": "static-1.10268",
  "onboarding-data-sync-lib": "static-1.1908",
  "hubspot-apollo-cache": "static-1.307",
  "calling-error-reporting": "static-1.31280",
  "shared-worker-versioning": "static-1.11009",
  "calling-usage-tracker": "static-1.6514",
  "voice-sms-access-library": "static-1.854",
  "conversations-skeleton-state": "static-1.7219",
  "location-customization-utils-lib": "static-1.9157",
  "crm-pipelines-api-client-types": "static-1.4117",
  "framework-builder-read-service-client": "static-1.3984",
  "framework-data-schema-quick-fetch": "static-1.6757",
  "persist-promise": "static-1.3670",
  "bend-plugin-pulse": "static-1.38",
  "directed-graph": "static-1.906",
  "event-emitter": "static-1.919",
  "fast-json-patch": "static-1.62",
  "data-agent-kit": "static-1.144",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9969",
  "fsm": "static-1.3702",
  "policy-lib": "static-1.6747",
  "react-tinymce": "static-1.55149",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10032",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54275",
  "tinymce-plugins": "static-1.57389",
  "tinymce-themes": "static-1.56245",
  "growth-onboarding-next-action-components": "static-1.1859",
  "user-context-client": "static-1.4583",
  "nest": "static-1.196",
  "unified-auth-core-lib": "static-1.736",
  "amplitude-session-replay-browser": "static-1.59",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4504",
  "video-embed": "static-1.35660",
  "content-icons-ui": "static-1.2216",
  "social-insights-client-types": "static-1.22006",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4783",
  "integrations-lib": "static-1.16019",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4235",
  "InboxConnectUtils": "static-4.14726",
  "calling-orchestration-schema": "static-1.35631",
  "crm-record-cards-service-types": "static-1.3583",
  "highcharts": "static-8.103",
  "trellis-story-utils": "static-1.4487",
  "storybook-react": "static-1.32",
  "hub-http-contrib": "static-1.3010",
  "tinymce-data": "static-1.40360",
  "ui-addon-sales-email": "static-1.5181",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12383",
  "layout-dnd-utils": "static-1.11358",
  "react-codemirror": "static-1.10596",
  "ui-brand-identity-lib": "static-1.15132",
  "NamespacedHubStyle": "static-2.9036",
  "outpost": "static-1.4157",
  "flux-actions": "static-1.331",
  "integrations-error-boundary-lib": "static-1.13434",
  "integrations-tracking-lib": "static-1.5570",
  "native-integrations-shared-strings": "static-1.7753",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10341",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.455",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68343",
  "layout-data-lib": "static-1.9683",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2984",
  "google-sheets-integration-lib": "static-1.143",
  "microsoft-drive-integration-lib": "static-1.260",
  "advanced-menus-core": "static-1.15082",
  "advanced-menus-lib": "static-1.12028",
  "ExportDialog": "static-6.10364",
  "ui-memberships-settings-lib": "static-1.33959",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15081",
  "simple-menus-lib": "static-1.16598"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2211",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.465",
  "data-fetching-client": "/data-fetching-client/static-1.9643",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.428",
  "growth-payments-core": "/growth-payments-core/static-1.25282",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5565",
  "hs-test-utils": "/hs-test-utils/static-1.7985",
  "hub-http": "/hub-http/static-1.6193",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9886",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18156",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11436",
  "I18n": "/I18n/static-7.1615",
  "immutable": "/immutable/static-2.77",
  "jasmine-runner": "/jasmine-runner/static-1.6438",
  "payment-link-components": "/payment-link-components/static-1.23447",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6986",
  "quartz-core": "/quartz-core/static-1.6205",
  "react": "/react/static-7.185",
  "react-colorpicker": "/react-colorpicker/static-2.10181",
  "react-dlb": "/react-dlb/static-1.78",
  "react-utils": "/react-utils/static-2.5319",
  "rich-text-lib": "/rich-text-lib/static-1.19775",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17940",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5574",
  "UIComponents": "/UIComponents/static-3.8383",
  "foundations-assets": "/foundations-assets/static-1.4834",
  "foundations-components": "/foundations-components/static-1.7868",
  "foundations-theming": "/foundations-theming/static-1.4388",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2104",
  "framer-motion": "/framer-motion/static-1.71",
  "metrics-js": "/metrics-js/static-1.9542",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "portals-platform-lib": "/portals-platform-lib/static-1.850",
  "quartz-config": "/quartz-config/static-1.764",
  "quartz-routing": "/quartz-routing/static-1.416",
  "quick-fetch": "/quick-fetch/static-1.3891",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16640",
  "rpc-client-utils": "/rpc-client-utils/static-1.4622",
  "sanitize-text": "/sanitize-text/static-1.8113",
  "styled-components": "/styled-components/static-2.88",
  "tanstack-table": "/tanstack-table/static-1.54",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4739",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9515",
  "usage-tracker": "/usage-tracker/static-1.7316",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5733",
  "usage-tracker-core": "/usage-tracker-core/static-1.7166",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3378",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3263",
  "quartz-webpack": "/quartz-webpack/static-1.3210",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.64",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.81",
  "customer-data-objects": "/customer-data-objects/static-1.7633",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7900",
  "laboratory-lib": "/laboratory-lib/static-3.7130",
  "onboarding-scopes": "/onboarding-scopes/static-1.6433",
  "ui-addon-opt": "/ui-addon-opt/static-4.8341",
  "HeadJS": "/HeadJS/static-2.746",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3096",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.60",
  "ts-schema": "/ts-schema/static-1.4053",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7703",
  "cssUtils": "/cssUtils/static-1.782",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9797",
  "HubStyle": "/HubStyle/static-2.11744",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.661",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9858",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11121",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9020",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10125",
  "video-components-external": "/video-components-external/static-1.11168",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4297",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6034",
  "customer-data-properties": "/customer-data-properties/static-1.51433",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18415",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5054",
  "onboarding-tours": "/onboarding-tours/static-1.16539",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8066",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3610",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9028",
  "user-context": "/user-context/static-1.5073",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.828",
  "hubspotter-http": "/hubspotter-http/static-1.4627",
  "icons": "/icons/static-2.644",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.520",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.661",
  "quartz-head": "/quartz-head/static-1.651",
  "quartz-test": "/quartz-test/static-1.661",
  "quartz-tracking": "/quartz-tracking/static-1.365",
  "ui-fonts": "/ui-fonts/static-1.698",
  "usage-tracker-container": "/usage-tracker-container/static-1.7306",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9399",
  "data-token-picker": "/data-token-picker/static-1.16351",
  "FileManagerLib": "/FileManagerLib/static-1.39169",
  "property-translator": "/property-translator/static-1.5372",
  "atom": "/atom/static-1.5042",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "purchase-motions-components": "/purchase-motions-components/static-1.5825",
  "salesImages": "/salesImages/static-1.524",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5351",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-virtualized": "/react-virtualized/static-2.98",
  "ui-images": "/ui-images/static-2.1143",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4137",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.13",
  "trellis-assets": "/trellis-assets/static-1.1770",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2871",
  "foundations-theming-base": "/foundations-theming-base/static-1.3373",
  "stylex": "/stylex/static-1.32",
  "interframe": "/interframe/static-3.4731",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5730",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "web-vitals": "/web-vitals/static-1.4",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.32",
  "chirp-fetch": "/chirp-fetch/static-1.1858",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4446",
  "react-flip-move": "/react-flip-move/static-1.69",
  "bender-build-tools": "/bender-build-tools/static-1.3160",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3818",
  "superstore": "/superstore/static-1.4736",
  "feedback-loader": "/feedback-loader/static-1.29238",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8859",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8671",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28461",
  "sassPrefix": "/sassPrefix/static-1.155",
  "react-dnd-compat": "/react-dnd-compat/static-1.4591",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2469",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8140",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4620",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12154",
  "content-media-compositions": "/content-media-compositions/static-2.16161",
  "idb-keyval": "/idb-keyval/static-1.43",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4125",
  "magpie-lib": "/magpie-lib/static-1.5537",
  "magpie-types": "/magpie-types/static-1.4997",
  "media-bridge-lib": "/media-bridge-lib/static-1.18871",
  "video-data-lib": "/video-data-lib/static-1.34826",
  "commerce-products-lib": "/commerce-products-lib/static-1.9437",
  "crm-message-bus": "/crm-message-bus/static-1.42906",
  "growth-data-modal": "/growth-data-modal/static-1.5379",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4848",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4753",
  "calling-global-api": "/calling-global-api/static-1.64410",
  "calling-internal-common": "/calling-internal-common/static-1.31274",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65792",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58086",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3772",
  "crm-links": "/crm-links/static-1.6256",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12996",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9213",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8056",
  "external-options-client-types": "/external-options-client-types/static-1.4133",
  "file-manager-components": "/file-manager-components/static-1.23529",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6852",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "hs-resources": "/hs-resources/static-1.123",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3565",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4198",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.603",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3666",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48630",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3940",
  "property-value-citations": "/property-value-citations/static-1.2047",
  "pulse": "/pulse/static-1.535",
  "smart-property-lib": "/smart-property-lib/static-1.6761",
  "tiered-pricing": "/tiered-pricing/static-1.1134",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10961",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3038",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1831",
  "navigation-components": "/navigation-components/static-1.17935",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.605",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7506",
  "ui-universal-auth": "/ui-universal-auth/static-1.8941",
  "batch-promise": "/batch-promise/static-1.1513",
  "navigation-messaging": "/navigation-messaging/static-1.7262",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17533",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9884",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5002",
  "audio-components": "/audio-components/static-1.5868",
  "FileManagerCore": "/FileManagerCore/static-1.39028",
  "FileManagerImages": "/FileManagerImages/static-1.36680",
  "video-components": "/video-components/static-1.13171",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.893",
  "purchase-motions-api": "/purchase-motions-api/static-1.5828",
  "self-service-api": "/self-service-api/static-1.10216",
  "signup-constants": "/signup-constants/static-1.18786",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8011",
  "trials-service-types": "/trials-service-types/static-1.3874",
  "usage-tracker-public": "/usage-tracker-public/static-1.7127",
  "chatspot-core": "/chatspot-core/static-1.21142",
  "ContentUtils": "/ContentUtils/static-1.68268",
  "copilot-toolkit": "/copilot-toolkit/static-1.11052",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6553",
  "reactive-lib": "/reactive-lib/static-1.693",
  "simple-logging-lib": "/simple-logging-lib/static-1.3020",
  "commerce-permissions": "/commerce-permissions/static-1.737",
  "customer-data-tracking": "/customer-data-tracking/static-1.6856",
  "products-iframe-lib": "/products-iframe-lib/static-1.7844",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10268",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1908",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.307",
  "calling-error-reporting": "/calling-error-reporting/static-1.31280",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11009",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6514",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.854",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7219",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9157",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4117",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3984",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6757",
  "persist-promise": "/persist-promise/static-1.3670",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.38",
  "directed-graph": "/directed-graph/static-1.906",
  "event-emitter": "/event-emitter/static-1.919",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "data-agent-kit": "/data-agent-kit/static-1.144",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9969",
  "fsm": "/fsm/static-1.3702",
  "policy-lib": "/policy-lib/static-1.6747",
  "react-tinymce": "/react-tinymce/static-1.55149",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10032",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54275",
  "tinymce-plugins": "/tinymce-plugins/static-1.57389",
  "tinymce-themes": "/tinymce-themes/static-1.56245",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1859",
  "user-context-client": "/user-context-client/static-1.4583",
  "nest": "/nest/static-1.196",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.736",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4504",
  "video-embed": "/video-embed/static-1.35660",
  "content-icons-ui": "/content-icons-ui/static-1.2216",
  "social-insights-client-types": "/social-insights-client-types/static-1.22006",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4783",
  "integrations-lib": "/integrations-lib/static-1.16019",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4235",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14726",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35631",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3583",
  "highcharts": "/highcharts/static-8.103",
  "trellis-story-utils": "/trellis-story-utils/static-1.4487",
  "storybook-react": "/storybook-react/static-1.32",
  "hub-http-contrib": "/hub-http-contrib/static-1.3010",
  "tinymce-data": "/tinymce-data/static-1.40360",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5181",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12383",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11358",
  "react-codemirror": "/react-codemirror/static-1.10596",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15132",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9036",
  "outpost": "/outpost/static-1.4157",
  "flux-actions": "/flux-actions/static-1.331",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13434",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5570",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7753",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10341",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.455",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68343",
  "layout-data-lib": "/layout-data-lib/static-1.9683",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2984",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.143",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.260",
  "advanced-menus-core": "/advanced-menus-core/static-1.15082",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12028",
  "ExportDialog": "/ExportDialog/static-6.10364",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33959",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15081",
  "simple-menus-lib": "/simple-menus-lib/static-1.16598"
}
};
